module.exports = __webpack_public_path__ + "static/img/test-center-text.a13596e6.png";